import { Alert } from "@material-ui/lab";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import UploadDucument from "components/ltr-request-document/components/UploadDucument";
import { useStyles } from "components/request-document/components/Commons";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { REQUEST_DOCUMENT_STEP_LTR, STATUS_PROCESS } from "libs/configs/constant";
import { LTR_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  documentRequiredSlice,
  getDocumentRequired, submitSmartForm, submitSmartFormSlice
} from "redux/modules/visaForm";

export default function UploadDucumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();

  const [isSaveDraft, setSaveDraft] = useState(false);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();

  const {
    draftId,
    addSmartFormState,
    getSmartForm,
    isTypeChange,
    smartform,
    submitSmartFormState,
  } = useSmartForm();
  const canEdit = useSelector(canEditForm);
  const { showLoading, hideLoading } = useModalLoading();

  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  useEffect(() => {
    if (smartserviceId) {
      dispatch(
        getDocumentRequired({
          smartserviceId,
          ...(isTypeChange && { ConditionType: "CHANGE" }),
          smartserviceGroupID: "LTR",
        })
      );
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
        smartserviceGroupID: "LTR",
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      showLoading();
    } else if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(documentRequiredSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          dispatch(setSmartFormStep(LTR_STEP.SUMMARIZE));
          dispatch(submitSmartForm({ draftId }));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
            smartserviceGroupID: "LTR",
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, showLoading]);

  useEffect(() => {
    if (!submitSmartFormState.isLoading) {
      if (submitSmartFormState.isSuccess) {
        hideLoading();
        // dispatch(setSmartFormStep(LTR_STEP.SUMMARIZE));
      } else if (submitSmartFormState.isFailure) {
        hideLoading();
        alert(submitSmartFormState.error?.message);
        dispatch(submitSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    dispatch,
    hideLoading,
    submitSmartFormState.error?.message,
    submitSmartFormState.isFailure,
    submitSmartFormState.isLoading,
    submitSmartFormState.isSuccess,
  ]);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Upload Document"
        subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR Wealthy Pensioner`}
      />
      {smartform.draftRemark && <Alert severity="error" style={{ marginTop: 18, marginBottom: 18 }}>{smartform.draftRemark}</Alert>}
      <Steper currentStep={4} isLTR stepInfo={REQUEST_DOCUMENT_STEP_LTR} />
      <UploadDucument
        setSaveDraft={setSaveDraft}
        handleSubmitForm={isDraftDocument}
        statusId={smartform?.statausID}
        handleClickBack={() =>
          dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP))
        }
      />
    </div>
  );
}
